import React from "react";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Center,
  Collapse,
  Divider,
  useDisclosure,
} from "@chakra-ui/react";

import { StepFrontend } from "@constants";
import { TimelineTypes } from "./timelineTypes";
import { EventBody, EventDetails, EventHeader } from "./partials";

type TimelineEventProps = {
  step: StepFrontend;
  item: TimelineTypes;
  isDefaultOpen: boolean;
};

export function TimelineEvent({
  step,
  item,
  isDefaultOpen = true,
}: TimelineEventProps) {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: isDefaultOpen });
  const {
    moduleId,
    mainComponentSerial,
    passed,
    stepName,
    timestamp,
    userName,
    comments,
    details,
    image,
  } = step;
  const extraData = React.useMemo(
    () =>
      Object.entries(details)
        .map(([name, data]) => ({
          name,
          data: (data ?? "undefined").toString(),
        }))
        .sort((a, b) => a.name.localeCompare(b.name))
        .filter((detail) => detail.data !== "undefined"),
    [details],
  );
  return (
    <Card>
      <CardHeader>
        <EventHeader
          stepName={stepName}
          isBodyCollapsed={isOpen}
          toggleBodyCollapse={onToggle}
        />
      </CardHeader>
      <Collapse in={isOpen} animateOpacity>
        <Center>
          <Divider w="95%" />
        </Center>
        <CardBody>
          <EventBody
            comments={comments}
            relatedSerials={[mainComponentSerial]}
            extraData={extraData}
            imageData={image || {}}
            stepName={stepName}
          />
        </CardBody>
      </Collapse>
      <Center>
        <Divider w="95%" />
      </Center>
      <CardFooter>
        <EventDetails
          passed={passed}
          completedBy={userName}
          completedOn={timestamp}
          item={item}
          moduleId={moduleId}
        />
      </CardFooter>
    </Card>
  );
}
